import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/utils/teams-app-navigation/navigate-to-teams-app';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';

export const getNavigateToTeamsApp = (
	orgId: string,
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	return navigateToTeamsAppBase({
		hostProduct: 'confluence',
		orgId,
		userHasNav4Enabled: true,
		shouldOpenInSameTab,
		...navActionPayload,
	});
};
